export var NewSolutionValueType;
(function (NewSolutionValueType) {
    NewSolutionValueType["input"] = "input";
    NewSolutionValueType["radio"] = "radio";
    NewSolutionValueType["additional"] = "additional";
    NewSolutionValueType["slider"] = "slider";
})(NewSolutionValueType || (NewSolutionValueType = {}));
[];
